import Loading from 'components/Loading';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
type Ref = {
  open: () => void;
  close: () => void;
};
export const bookingV2LoadingRef = React.createRef<Ref>();
const BookingV2Loading = forwardRef<Ref>((_, ref) => {
  const [visible, setVisible] = useState(false);
  useImperativeHandle(ref, () => ({
    open: () => setVisible(true),
    close: () => setVisible(false),
  }));
  if (!visible) return null;
  return (
    <Container><Loading /></Container>
  );
});
BookingV2Loading.displayName = 'BookingV2Loading';
export default BookingV2Loading;

const Container = styled.div`
position: fixed;
inset: 0;
background: rgba(255,255,255,0.3);
z-index: 9999;
display: flex;
align-items: center;
justify-content: center;
`;
